<template>
  <vv-box :title="$t('userAccount.personalAddresses')" :unpadded="true">
    <div class="container">
      <h5>{{ $t('forms.shippingAddress') }}</h5>

      <vv-form-text-input
        label="address"
        id="address"
        v-model="shippingAddress"
        :validate="'required'"
      />
      <vv-form-text-input
        label="complement"
        id="complement"
        v-model="shippingComplement"
      />

      <vv-form-text-input
        label="postalCode"
        id="postal-code"
        v-model="shippingPostalCode"
        :validate="'required|numeric'"
      />
      <vv-form-text-input label="city" id="city" v-model="shippingCity" :validate="'required'" />

      <vv-form-checkbox-input
        label="shippingForBilling"
        id="shipping-for-billing"
        v-model="shippingForBilling"
      />

      <div v-if="!shippingForBilling">
        <vv-form-text-input
          label="billingAddress"
          id="billing-address"
          v-model="billingAddress"
          :validate="'required'"
        />
        <vv-form-text-input
          label="billingComplement"
          id="billing-complement"
          v-model="billingComplement"
          :validate="'required'"
        />

        <vv-form-text-input
          label="billingPostalCode"
          id="billing-postal-code"
          v-model="billingPostalCode"
          :validate="'required|numeric'"
        />
        <vv-form-text-input
          label="billingCity"
          id="billing-city"
          v-model="billingCity"
          :validate="'required'"
        />
      </div>

      <vv-button class="validate-button" @click="updateAddress">
        {{ $t('forms.validate') }}
      </vv-button>
      <br v-if="error || success" />
      <span v-if="error">{{ $t(errorMessage) }}</span>
      <span v-if="success">{{ $t('forms.updatedWithSuccess') }}</span>
    </div>
  </vv-box>
</template>

<script>
import VvBox from '@/components/common/VvBox'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import VvFormCheckboxInput from '@/components/common/forms/VvFormCheckboxInput'
import VvFormBirthdayInput from '@/components/common/forms/VvFormBirthdayInput'
import VvButton from '@/components/common/VvButton'
import userMixin from '@/mixins/user'

export default {
  name: 'UserAccountAddresses',
  mixins: [userMixin],
  components: {
    VvBox,
    VvFormTextInput,
    VvFormBirthdayInput,
    VvFormCheckboxInput,
    VvButton
  },
  data: () => ({
    shippingAddress: '',
    shippingComplement: '',
    shippingPostalCode: '',
    shippingCity: '',
    billingAddress: '',
    billingComplement: '',
    billingPostalCode: '',
    billingCity: '',
    shippingForBilling: true,
    isLoading: false,
    error: false,
    errorMessage: '',
    success: false
  }),
  methods: {
    async updateAddress() {
      this.error = false
      this.errorMessage = 'forms.updatedWithError'
      this.success = false

      const validFields = await Promise.all(
        this.$children.map(child => child.$validator.validateAll())
      )
      if (validFields.some(verification => verification === false)) {
        return
      }

      const updatePayload = {
        shippingAddress: this.shippingAddress,
        shippingComplement: this.shippingComplement,
        shippingPostalCode: this.shippingPostalCode,
        shippingCity: this.shippingCity
      }

      if (!this.shippingForBilling) {
        updatePayload['billingAddress'] = this.billingAddress
        updatePayload['billingComplement'] = this.billingComplement
        updatePayload['billingPostalCode'] = this.billingPostalCode
        updatePayload['billingCity'] = this.billingCity
      } else {
        updatePayload['billingAddress'] = this.shippingAddress
        updatePayload['billingComplement'] = this.shippingComplement
        updatePayload['billingPostalCode'] = this.shippingPostalCode
        updatePayload['billingCity'] = this.shippingCity
      }

      updatePayload['shippingForBilling'] = this.shippingForBilling

      try {
        await this.updateUserInformations(updatePayload)

        this.success = true
        setTimeout(() => (this.success = false), 4000)
      } catch (error) {
        this.error = true
        if (error.code) {
          this.errorMessage = error.code
        }

        setTimeout(() => (this.error = false), 4000)
      }
    }
  },
  mounted() {
    if (this.user) {
      this.shippingAddress = this.user.shippingAddress || ''
      this.shippingComplement = this.user.shippingComplement || ''
      this.shippingPostalCode = this.user.shippingPostalCode || ''
      this.shippingCity = this.user.shippingCity || ''

      this.billingAddress = this.user.billingAddress || ''
      this.billingComplement = this.user.billingComplement || ''
      this.billingPostalCode = this.user.billingPostalCode || ''
      this.billingCity = this.user.billingCity || ''

      this.shippingForBilling = this.user.shippingForBilling || true
    }
  },
  provide() {
    return { $validator: this.$validator }
  }
}
</script>

<style scoped lang="scss">
.container {
  margin: 17px 17px 23px 17px;
}

.multi-col {
  display: flex;
  flex-direction: row;
}
.validate-button{
  width: 200px;
  margin-left: 40%;
  @media screen and (max-width: 719px) {
    width: 76%; 
    margin-left: 0;  
  }
}
</style>
